module.exports = __webpack_public_path__ + "static/media/igarashiMotors.3fbb6ad2.svg";